import FacebookIcon from "../../assets/icons/FacebookIcon";
import LinkedInIcon from "../../assets/icons/LinkedInIcon";
import WhatsAppIcon from "../../assets/icons/WhatsAppIcon";
import InstagramIcon from "../../assets/icons/InstagramIcon";

const quickAccessLinks = [
  // {
  //   url: "http://www.fem.unicamp.br/index.php/pt-br/institucional/diretoria",
  //   text: "Diretoria",
  // },
  // {
  //   url: "http://www.fem.unicamp.br/index.php/pt-br/de-sobrenos",
  //   text: "Departamento de Energia",
  // },
  {
    url: "http://www.fem.unicamp.br/index.php/pt-br/demm-sobrenos",
    text: "Departamento de Engenharia de Manufatura e Materiais",
  },
  // {
  //   url: "http://www.fem.unicamp.br/index.php/pt-br/dmc-sobrenos",
  //   text: "Departamento de Mecânica Computacional",
  // },
  // {
  //   url: "http://www.fem.unicamp.br/index.php/pt-br/dsi-sobrenos",
  //   text: "Departamento de Sistemas Integrados",
  // },
  // {
  //   url: "http://www.pg.unicamp.br/mostra_norma.php?id_norma=22826",
  //   text: "POLÍTICA DE SEGURANÇA DA INFORMAÇÃO DA UNICAMP (Deliberação CONSU-A-031/2020, de 04/08/2020)",
  // },
];

const otherLinks = [
  {
    url: "https://www.bae.unicamp.br/",
    text: "Biblioteca da Área de Engenharia - BAE",
  },
  // {
  //   url: "http://www.dac.unicamp.br/",
  //   text: "Diretoria Acadêmica - DAC"
  // },
  // {
  //   url: "http://www.sae.unicamp.br/",
  //   text: "Serviço de Apoio ao Estudante - SAE"
  // },
  {
    url: "http://www.sbu.unicamp.br/",
    text: "Sistema de Bibliotecas da Unicamp - SBU",
  },
  {
    url: "http://www.unicamp.br/sipex/",
    text: "Sistema de Informação de Pesquisa - SiPEx",
  },
  // ---
  // {
  //   url: "http://www.capes.gov.br/",
  //   text: "Fundação Capes",
  // },
  // {
  //   url: "http://www.cnpq.br/",
  //   text: "CNPq",
  // },
  // {
  //   url: "http://www.fapesp.br/",
  //   text: "Fapesp",
  // },
  // {
  //   url: "http://www.finep.gov.br/",
  //   text: "Finep",
  // },
  // ---
  // {
  //   url: "https://www.ggte.unicamp.br/",
  //   text: "Ensino Aberto Unicamp - GGTE",
  // },
  // {
  //   url: "http://www.ccuec.unicamp.br/ccuec/rede_sem_fio",
  //   text: "Rede sem Fio Unicamp - Eduroam",
  // },
  // {
  //   url: "http://www.prefeitura.unicamp.br/",
  //   text: "Prefeitura da Unicamp",
  // },
];

const mediaLinks = [
  {
    url: "https://www.instagram.com/lmudemm/",
    Icon: InstagramIcon,
  },
  {
    url: "https://www.linkedin.com/in/lmufemunicamp/?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    Icon: LinkedInIcon,
  },
  {
    url: "#",
    Icon: FacebookIcon,
  },
  {
    url: "https://wa.me/qr/CGPC3MLVEXLBH1",
    Icon: WhatsAppIcon,
  },
];

export { quickAccessLinks, otherLinks, mediaLinks };
